import _ from "lodash";
import moment from "moment";
import { CollectionAdapter } from "../../main/adapters/CollectionAdapter/CollectionAdapter";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";
import { DateHelper } from "../../presentation/services/DateHelper/DateHelper";
import * as DateUtils from "../../utils/date/date";

const AvailableCollection = new Mongo.Collection("Availables", {
    connection: null
});

export class Available extends CollectionAdapter {
    HttpAdapter = new HttpAdapter();
    baseUrlDataTimeseries = `${publicSettings.aws.baseUrls.dataTimeseries}`;
    constructor() {
        super(AvailableCollection);
    }

    // TODO: Refatorar para usecase
    get({ companyId, scenarioId, source, options = {} }) {
        const availables = this.findOneCollection({
            companyId: { $eq: companyId }
        });
        let scenarioIdAvailable = scenarioId;
        if (options.projection && options.projection != "PROGRESSAO_LINEAR")
            scenarioIdAvailable = options.projection;
        const available =
            _.get(availables, `date.${scenarioIdAvailable}.${source}`) || [];

        let projectionDates = [];

        if (options.projection) {
            projectionDates = this.getDatesToUse({
                currentProjection: options.projection,
                available: _.uniq(available.sort()),
                availables,
                source,
                scenarioId
            });
        }
        if (options.budget) {
            projectionDates =
                _.get(availables, `date.${options.budget}.${source}`) || [];
        }
        const newDates = [...available, ...projectionDates].map((dt) =>
            new Date(dt).toISOString()
        );
        if (options.separatted)
            return {
                availableDates: _.uniq(available.sort()),
                projectionDates: _.uniq(projectionDates.sort()),
                allDates: _.uniq(newDates.sort())
            };
        return _.uniq(newDates.sort());
    }

    // TODO: Transferir para service de Available
    getDatesToUse({
        currentProjection = false,
        available,
        availables,
        source,
        scenarioId,
        totalMonths = 12
    }) {
        let newDates = [];
        if (currentProjection === "PROGRESSAO_LINEAR") {
            newDates = DateUtils.generateNewMonths(
                available,
                totalMonths,
                true
            );
        } else {
            const baseAvailable = availables.date?.[scenarioId]?.[source] || [];
            const projectionAvailable = this._getProjectionAvailable({
                availables,
                currentProjection,
                source,
                baseAvailable,
                totalMonths
            });
            newDates = [...projectionAvailable, ...baseAvailable];
        }

        return newDates;
    }

    _getProjectionAvailable({
        availables,
        currentProjection,
        source,
        baseAvailable,
        totalMonths = 12
    }) {
        const available =
            _.get(availables, `date.${currentProjection}.${source}`) || [];
        const projectionAvailable = _.uniq(available).sort();
        const diffAvailable = _.difference(projectionAvailable, baseAvailable);
        const resultAvailable = diffAvailable.slice(0, totalMonths);
        return resultAvailable;
    }

    // TODO: Refatorar para usecase
    getByFilterDate({
        companyId,
        scenarioId,
        source,
        currentDate,
        currentComparation,
        availableFilter,
        analysisPeriod,
        allMonthsByYear,
        projection,
        budget,
        allYearsAvailable
    }) {
        if (allMonthsByYear) return DateUtils.monthsByYear(allMonthsByYear);

        const { availableDates, allDates } = this.get({
            companyId,
            scenarioId,
            source,
            options: { projection, separatted: true, budget }
        });
        let _available = allDates;
        if (allYearsAvailable) return _available;
        if (currentComparation) {
            const currentDates = _available.filter((d) => {
                const date = new Date(d);
                const year = date.getUTCFullYear();
                return year === currentDate.year;
            });
            const comparationDates = _available.filter((d) => {
                const date = new Date(d);
                const year = date.getUTCFullYear();
                return year === currentComparation.year;
            });
            const mergedDates = _.uniq([...currentDates, ...comparationDates]);
            _available = mergedDates.sort();
            return projection ? availableDates : _available;
        }
        if (currentDate) {
            const index = _available.findIndex((d) => {
                const date = new Date(d);
                const month = date.getUTCMonth() + 1;
                const year = date.getUTCFullYear();
                return month == currentDate.month && year == currentDate.year;
            });
            if (availableFilter === "only") _available = [_available[index]];
            else {
                const totalMonths = {
                    monthly: 13,
                    quarterly: 12 + 12 + 12 + 12 + 12 + 12 + 12 + 12 + 12,
                    semester: 12 + 12 + 12 + 12 + 12 + 12 + 12 + 12,
                    yearly: 12 + 12 + 12 + 12 + 12 + 12 + 12 + 12 + 12 + 12
                };

                const availableCopy = _available;
                if (index > -1) availableCopy.splice(index + 1);
                availableCopy.splice(
                    0,
                    availableCopy.length - totalMonths[analysisPeriod]
                );

                _available = availableCopy;
            }
        }
        if (projection === "PROGRESSAO_LINEAR")
            return availableDates.slice(-12);
        return _available;
    }

    // TODO: Refatorar para usecase
    getYears(companyId, source, scenarioId = "ORIGINAL", options = {}) {
        try {
            const availables = this.findOneCollection({
                companyId: { $eq: companyId }
            });

            let dates = [];
            if (options.projection) {
                const datesToUse = this.getDatesToUse({
                    currentProjection: options.projection,
                    available: availables.date[scenarioId][source],
                    availables,
                    source,
                    scenarioId
                });
                const availableDates =
                    availables.date[scenarioId][source] || [];
                const allDates = availableDates.concat(datesToUse);
                dates = _.uniq(allDates).sort();
            } else {
                dates = availables.date[scenarioId][source];
            }

            const years = [];

            dates.forEach((date) => {
                const year = parseInt(
                    moment(date).add("month", 1).format("YYYY")
                );

                if (years.indexOf(year) == -1) {
                    years.push(year);
                }
            });

            return years.sort((a, b) => a - b);
        } catch (error) {
            return [];
        }
    }

    getMonths(
        companyId,
        selectYear,
        source = "accounting",
        scenarioId = "ORIGINAL",
        options = {}
    ) {
        const dates = this.get({ companyId, scenarioId, source, options });
        const labelMonths = DateUtils.months();
        const months = [];
        dates.forEach((date) => {
            const year = new Date(date).getUTCFullYear();
            if (year == selectYear) {
                const month = new Date(date).getUTCMonth();
                months.push({
                    date,
                    monthNumber: String(month + 1).padStart(2, "0"),
                    month: labelMonths[month]
                });
            }
        });
        const response = labelMonths.map((month) => {
            const match = months.find((m) => month == m.month);
            return {
                available: match ? true : false,
                ...match,
                month
            };
        });

        return response;
    }

    getListScenarios(companyId) {
        const available = this.findOneCollection({
            companyId: { $eq: companyId }
        });

        if (!available) return [];

        const scenarios = [];

        _.forEach(available.date, (value, key) => {
            scenarios.push(key);
        });

        if (scenarios.length == 1) {
            if (scenarios[0] == "ORIGINAL") return [];
        }
        return scenarios;
    }

    // TODO: Refatorar para usecase
    getScenario({ companyId, source }) {
        const availables = this.findOneCollection({
            companyId: { $eq: companyId }
        });

        if (!availables) return "ORIGINAL";

        let hasOriginal = false;

        if (source) {
            hasOriginal = _.get(availables, `date.ORIGINAL.${source}`);

            if (source === "tax" && !hasOriginal)
                hasOriginal = _.get(
                    availables,
                    `date.ORIGINAL.simplesNacional`
                );
        } else hasOriginal = _.get(availables, `date.ORIGINAL`);

        if (!hasOriginal) {
            const dates = _.get(availables, `date`);

            let scenariosIds = [];

            if (source) {
                Object.filter = (obj, predicate) =>
                    Object.fromEntries(Object.entries(obj).filter(predicate));

                const availableFiltered = Object.filter(
                    dates,
                    ([key, values]) => Object.keys(values).includes(source)
                );

                if (availableFiltered) {
                    scenariosIds = Object.keys(availableFiltered);
                }

                if (scenariosIds.length) return scenariosIds[0];
            }

            if (dates) {
                scenariosIds = _.sortBy(
                    Object.keys(dates),
                    (s) => s != "ORIGINAL"
                );
            }

            if (scenariosIds.length) return scenariosIds[0];
        }

        return "ORIGINAL";
    }

    // TODO: Transferir para service de Available
    getLastMonth(
        companyId,
        selectYear,
        source = "accounting",
        scenarioId = "ORIGINAL",
        options = {}
    ) {
        const dates = this.get({ companyId, scenarioId, source, options });
        const months = [];
        if (!dates) return null;
        dates.forEach((date) => {
            const year = new Date(date).getUTCFullYear();
            if (year == selectYear) {
                const month = new Date(date).getUTCMonth() + 1;
                months.push(String(month).padStart(2, "0"));
            }
        });
        return _.last(months.sort());
    }

    // TODO: Refatorar para usecase
    getAllAvailable(companyId) {
        const availables = this.findOneCollection({
            companyId: { $eq: companyId }
        });

        return this.sort(availables);
    }

    sort(available) {
        _.each(_.get(available, "date"), (scenarioSources) => {
            if (scenarioSources.accounting) {
                scenarioSources.accounting = scenarioSources.accounting.sort(
                    (a, b) => new Date(a) - new Date(b)
                );
                scenarioSources.accounting = this._normalizeDates(
                    scenarioSources.accounting
                );
            }

            if (scenarioSources.financial)
                scenarioSources.financial = scenarioSources.financial.sort(
                    (a, b) => new Date(a) - new Date(b)
                );

            if (scenarioSources.personnel) {
                scenarioSources.personnel = scenarioSources.personnel.sort(
                    (a, b) => new Date(a) - new Date(b)
                );

                scenarioSources.personnel = this._normalizeDates(
                    scenarioSources.personnel
                );
            }

            if (scenarioSources.tax) {
                scenarioSources.tax = scenarioSources.tax.sort(
                    (a, b) => new Date(a) - new Date(b)
                );

                scenarioSources.tax = this._normalizeDates(scenarioSources.tax);
            }

            if (scenarioSources.covid)
                scenarioSources.covid = scenarioSources.covid.sort(
                    (a, b) => new Date(a) - new Date(b)
                );
        });
        return available;
    }

    _normalizeDates = (dates) => {
        if (!dates) return [];
        const datesNormalized = dates.map(
            (d) => new Date(new DateHelper(d).startOf("month"))
        );

        return _.uniqWith(datesNormalized, _.isEqual);
    };

    // TODO: Refatorar para usecase
    saveAndPopulate({
        companyId,
        source,
        newDates,
        scenarioId = "ORIGINAL",
        override = false,
        allAvailable = false
    } = {}) {
        const available = this.findOneCollection({
            companyId: { $eq: companyId }
        });

        if (!available) {
            const toInsert = {
                _id: companyId,
                companyId,
                date: { [`${scenarioId}`]: { [`${source}`]: newDates } }
            };

            this.create(toInsert);

            const avaliableAfter = this.findOneCollection({
                companyId: { $eq: companyId }
            });
        } else if (override) {
            const newDateYears = [];
            newDates.forEach((date) => {
                const year = new Date(date).getUTCFullYear();
                if (newDateYears.indexOf(year) == -1) {
                    newDateYears.push(year);
                }
            });

            const currentAvailable = available.date[scenarioId][source] || [];

            const keepAvailable = currentAvailable.filter((available) => {
                return !newDateYears.includes(
                    new Date(available).getUTCFullYear()
                );
            });

            const updateAvailable = newDates.concat(keepAvailable);

            this.modify(
                {
                    companyId: { $eq: companyId }
                },
                {
                    $set: {
                        [`date.${scenarioId}.${source}`]: allAvailable
                            ? newDates
                            : updateAvailable
                    }
                }
            );
        } else {
            const currentAvailable = _.get(
                available,
                `date[${scenarioId}][${source}]`,
                []
            );

            const newAvailable = [...currentAvailable, ...newDates];

            const timeStampDates = newAvailable.map((date) => +new Date(date));

            const uniqDates = _.uniq(timeStampDates);

            const regularDates = uniqDates.map((date) =>
                new Date(date).toISOString()
            );

            const response = this.modify(
                {
                    companyId: { $eq: companyId }
                },
                {
                    $set: {
                        [`date.${scenarioId}.${source}`]: regularDates
                    }
                }
            );
        }

        return true;
    }

    // TODO: Refatorar para usecase
    getAvailableByIntervals({
        companyId,
        source,
        scenarioId,
        startDate,
        currentDate,
        currentComparation,
        projection,
        budget,
        options = {}
    }) {
        let dates = [];
        const { availableDates, allDates, projectionDates } = this.get({
            companyId,
            scenarioId,
            source,
            options: { projection, separatted: true, budget }
        });
        if (options.type === "allDates") dates = allDates;
        else if (options.type === "projectionDates") dates = projectionDates;
        else dates = availableDates;
        const regularStartMonth = String(startDate.month).padStart(2, "0");
        const _startDate = new Date(
            `${startDate.year}-${regularStartMonth}-01`
        );
        const startIndex = dates.findIndex((date) => {
            const _date = new Date(date);
            return (
                _date.getUTCFullYear() === _startDate.getUTCFullYear() &&
                _date.getUTCMonth() === _startDate.getUTCMonth()
            );
        });
        let datesByStart = _.drop(dates, startIndex);
        const regularCurrentMonth = String(currentDate.month).padStart(2, "0");
        const _currentDate = new Date(
            `${currentDate.year}-${regularCurrentMonth}-01`
        );
        const endIndex = datesByStart.findIndex((date) => {
            const _date = new Date(date);
            return (
                _date.getUTCFullYear() === _currentDate.getUTCFullYear() &&
                _date.getUTCMonth() === _currentDate.getUTCMonth()
            );
        });
        if (endIndex === -1) {
            const comparationDate = this.getComparationDate(currentComparation);
            if (comparationDate && projection != "PROGRESSAO_LINEAR")
                datesByStart.push(comparationDate);
            return _.uniq(datesByStart).sort();
        }
        datesByStart.splice(endIndex + 1);
        const comparationDate = this.getComparationDate(currentComparation);
        if (comparationDate) datesByStart.push(comparationDate);
        return _.uniq(datesByStart).sort();
    }

    getComparationDate(currentComparation) {
        if (currentComparation) {
            const comparationDate = new Date(
                `${currentComparation.year}-${String(
                    currentComparation.month
                ).padStart(2, "0")}-01`
            );
            return comparationDate.toISOString();
        }
        return false;
    }

    async getDates({ companyIds, options }) {
        if (!companyIds) return null;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/point/available`,
                {
                    companyIds: [].concat(companyIds),
                    options: options
                }
            );
            return response;
        } catch (error) {
            throw new Error(
                error?.message || "Erro ao buscar disponibilidade de pontos"
            );
        }
    }
}
